module.exports = __webpack_public_path__ + "img/lv.6d9baaa8.png";